import { AuthClient, PatientOrder, PatientOrdersClient } from '../../../../generated';
import { httpRequest } from '../../../../utils';

const patientOrderPost = async (patientOrder: PatientOrder) => {
  const patientOrdersClient = new PatientOrdersClient(new AuthClient());

  const orderID = await httpRequest(() => patientOrdersClient.patientOrdersPost(patientOrder));

  return orderID;
};

export { patientOrderPost };
